import React from 'react'
import { FormGroup, HelpText, Link, Label } from './'

export const FormGroupLink = props => {
    const { element } = props;

    return (
        <FormGroup required={element.required}>
            <Label text={element.labelText}></Label><br />
            <Link {...props}></Link>
            <HelpText text={element.helpText}></HelpText>   
        </FormGroup>
    )
}

export default FormGroupLink;